import React from 'react';
import CssBaselineBase from '@material-ui/core/CssBaseline';

const CssBaseline = (props) => <CssBaselineBase {...props} />;

export default CssBaseline;
